// extracted by mini-css-extract-plugin
export default {"container":"HomeCard_container__aY244","header":"HomeCard_header__98qMi","icon":"HomeCard_icon__-BFs+","title":"HomeCard_title__LE8d1","content":"HomeCard_content__ZGrBD"};